const IndexSupplierProgram = () => import('./supplier_program/pages/index')
const DetailSupplierProgram = () => import('./supplier_program/components/detail')

export default [
  {
    path: '/antecipation_requests',
    name: 'antecipation_requests.index',
    component: IndexSupplierProgram,
    meta: { requiresAuth: true }
  },
  {
    path: '/antecipation_requests/:id/details',
    name: 'antecipation_requests.detail',
    component: DetailSupplierProgram,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/antecipation_request/routes.js